import { __assign } from 'tslib';
import { ICON_MAP } from '../consts/iconMap.js';

var useStatusBadgeIcon = function (view, size, customIcons) {
    var iconsMap = ICON_MAP;
    // transform initial icons map
    if (customIcons) {
        iconsMap = Object.keys(ICON_MAP).reduce(function (acc, current) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {},
                _a[current] = __assign(__assign({}, ICON_MAP[current]), customIcons[current]),
                _a)));
        }, {});
    }
    var Icon = iconsMap[view][size];
    return { Icon: Icon };
};

export { useStatusBadgeIcon };
